import React from "react";
import ImageQueHablamos from "../../images/modulo14/quehablamoslosperuanos.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from "@fortawesome/free-solid-svg-icons";
import LayoutActividad from "../../components/LayoutActividad";
import Sidebar from "./Sidebar";
import { modulo14 } from "../../routes/Module14";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo14/Inicio.mp3";

const QueHablamos = () => {
  const nextUnity = modulo14.content[0];
  const nextActivity = nextUnity.activities[0];

  const pages = {
    titleNext: `${nextUnity.name}: ${nextActivity.name}`,
    linkNext: `${modulo14.url}/${nextUnity.path}/${nextActivity.path}`,
  };
  const crumbs = [
    {
      title: `${modulo14.title} > Inicio `,
      url: "/" + modulo14.url,
    },
  ];
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">{modulo14.title}</h1>
      <AudioPlayer track={Audio} />


      <div className="header-img">
        <img
          src={ImageQueHablamos}
          className="card-img-top full-width"
          alt="..."
        />
      </div>

      <div className="row mt-5">
        <div className="col-md-8 col-sm-12">
          <p>
            En este módulo conoceremos la diversidad de lenguas del Perú. Para
            ello aprenderemos sobre las lenguas originarias de nuestro país, el
            castellano peruano y la discriminación lingüística. Como hemos
            venido haciendo a lo largo de este nivel, pensaremos en la
            importancia de convivir, deliberar y participar a favor de un país
            en que se respeten todas nuestras lenguas.
          </p>

          <ul>
            <li>
              Identificamos la diversidad de lenguas y variedades lingüísticas
              que componen el Perú.
            </li>
            <li>
              Conocemos procesos históricos que explican la diversidad
              lingüística.
            </li>
            <li>
              Compartimos nuestras experiencias personales a partir de lo
              aprendido.
            </li>
            <li>
              Reflexionamos sobre la importancia de la diversidad lingüística y
              nos reconocemos como parte de ella.
            </li>
          </ul>
          <div className="unit-options my-5">
            <a href={"https://ciudadania.pe/actividades-interactivas/" + pages.linkNext}>
              <button className={`btn btn-${modulo14.color} me-2`}>
                Empezar actividades <FontAwesomeIcon icon={faMap} />
              </button>
            </a>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que, en silencio, lean la pregunta que
            aparece y que observen la ilustración. Pregunte y
            recoja sus respuestas:
            <ul>
              <li>
                <i>
                  “A partir de lo observado, ¿de qué creen que tratará este
                  módulo”. Resalte que se pregunta por las lenguas que se hablan
                  en el Perú. Pregunte qué lenguas conocen. De
                  otro lado, señale que en la ilustración se muestra la plaza de
                  una ciudad. Pida que describan el lugar.
                  Resalte que en la ilustración hay personas interactuando y
                  también se pueden leer varios carteles. En esos carteles
                  podemos encontrar palabras que muestran la diversidad de
                  lenguas que hay en el Perú”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora, lea el texto que explica de qué tratará esta unidad y lo que
            se busca con las actividades a realizar.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default QueHablamos;
